// UBB-407: Hide bundle-specific elements in the Loop subscription portal.
// CSS can't match text content patterns, so a MutationObserver watches for
// Loop's React-rendered elements and hides them by text.
// Non-bundle promo codes and Edit buttons are unaffected.
//
// Elements targeted:
//   - .loop-discount-label pills inside #loop-discounts-card whose text
//     contains LPBNDL (the bundle code prefix).
//   - "Remove" buttons inside .loop-cp-bundle-edit-delete-btn-wrapper.
//     The same wrapper also holds "Edit" buttons which must remain visible.

const BUNDLE_CODE_PREFIX = 'LPBNDL';

function hideBundleElements() {
  // Discount code label pills in the discounts card
  document
    .querySelectorAll('#loop-discounts-card .loop-discount-label')
    .forEach((label) => {
      if (label.textContent.trim().includes(BUNDLE_CODE_PREFIX)) {
        label.style.display = 'none';
      }
    });

  // "Remove" buttons in the bundle edit/delete wrapper — leave "Edit" alone
  document
    .querySelectorAll('.loop-cp-bundle-edit-delete-btn-wrapper button')
    .forEach((btn) => {
      if (btn.textContent.trim() === 'Remove') {
        btn.style.display = 'none';
      }
    });
}

// Run immediately in case Loop has already rendered by the time this executes
hideBundleElements();

// Watch for dynamic renders — Loop is a React app that mounts asynchronously
const observer = new MutationObserver(hideBundleElements);
observer.observe(document.body, { childList: true, subtree: true });
